module.exports = __webpack_public_path__ + "img/main_architecture_image03.6a5e89d3.png";